// Centralized API URL configuration
// All API endpoints should be imported from here to ensure consistency

const isProduction = import.meta.env.PROD || process.env.NODE_ENV === 'production';

// Betty API (music assistant, transcription, synthesis)
export const BETTY_API_URL = isProduction
  ? 'https://blagmanbros.com/api'
  : 'http://localhost:8002/api';

// CRM API (publisher/track management)
export const CRM_API_URL = import.meta.env.VITE_CRM_API_URL ?? (
  isProduction
    ? 'https://blagmanbros.com/api/crm'
    : 'http://localhost:8002/api/crm'
);

// Base API URL (without service-specific paths)
export const API_BASE_URL = isProduction
  ? 'https://blagmanbros.com/api'
  : 'http://localhost:8002/api';
